import React from 'react';
import { Box, Typography } from 'housecall-ui';

import { formatMoney } from 'components/OnlineBookingSettings/utils/formatMoney';

import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';

export const SelectedServiceHeader = () => {
  const { state } = useOnlineBookingReducer();

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" mb={1.5}>
      <Typography variant="subtitle2">{state.service?.name}</Typography>
      <Typography variant="subtitle2">{formatMoney(state.service?.price ?? 0)}</Typography>
    </Box>
  );
};
